import store from "store"

function getCurrentUserId() {
  const authenticatedUser = store.getState().authentication.authenticatedUser
  return authenticatedUser?.user_id
}

export default getCurrentUserId
